import { useCallback, useEffect, useState } from "react";

const subscribers = new Set();
let timer = null, lastAutomaticRefresh = 0;
const notify = () => subscribers.forEach(fn => fn());
export const refreshLiveData = () => notify();
const automaticRefresh = () => {
  const editing = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
  if (document.visibilityState !== "visible" || editing || Date.now() - lastAutomaticRefresh < 500) return;
  lastAutomaticRefresh = Date.now();
  notify();
};

// One shared clock refreshes read views; never remount pages or reset form state.
export const useLiveRefresh = () => {
  const [version, setVersion] = useState(0);
  const refresh = useCallback(refreshLiveData, []);
  useEffect(() => {
    const update = () => setVersion(v => v + 1);
    subscribers.add(update);
    if (subscribers.size === 1) {
      timer = window.setInterval(automaticRefresh, 60000);
      window.addEventListener("focus", automaticRefresh);
      document.addEventListener("visibilitychange", automaticRefresh);
    }
    return () => {
      subscribers.delete(update);
      if (!subscribers.size) {
        window.clearInterval(timer);
        window.removeEventListener("focus", automaticRefresh);
        document.removeEventListener("visibilitychange", automaticRefresh);
      }
    };
  }, []);
  return [version, refresh];
};